import React from 'react';
import { Dialog } from 'primereact/dialog';

const EmployeeDialog = ({ employee, visible, onHide }) => {
  if (!employee) return null;

  const formatDate = (value) => {
    if (!value) return 'Belirtilmemiş';
    try {
      return new Date(value).toLocaleDateString('tr-TR');
    } catch (error) {
      return value;
    }
  };

  const formatEndDate = (value) => {
    if (!value) return 'Halen';
    return formatDate(value);
  };

  return (
    <Dialog
      header="Çalışan Detayları"
      visible={visible}
      style={{ width: '500px' }}
      modal
      onHide={onHide}
    >
      <div className="p-fluid">
        <div className="p-field"><b>Ad:</b> {employee.first_name}</div>
        <div className="p-field"><b>Soyad:</b> {employee.last_name}</div>
        <div className="p-field"><b>Email:</b> {employee.email}</div>
        <div className="p-field"><b>Telefon:</b> {employee.phone_number}</div>
        <div className="p-field"><b>Doğum Tarihi:</b> {employee.birth_date}</div>
        <div className="p-field"><b>İşe Başlama Tarihi:</b> {employee.start_date}</div>
        <div className="p-field"><b>Aktif mi?:</b> {employee.is_active ? 'Evet' : 'Hayır'}</div>
        <div className="p-field"><b>İzin Onay Süreci:</b> {employee.approval_hierarchy ? employee.approval_hierarchy.name : null}</div>
        <div className="p-field"><b>Harcama Onay Süreci:</b> {employee.expense_approval_hierarchy ? employee.expense_approval_hierarchy.name : null}</div>
        <div className="p-field">
          <b>Departman ve Pozisyonlar:</b>
          <ul>
            {(employee.departments_with_positions || []).map((dp, i) => (
              <li key={i}>
                <div className="flex flex-column">
                  <span>{dp.department_name} - {dp.position_name}</span>
                  <span className="text-xs opacity-70">Başlangıç: {formatDate(dp.start_date)}</span>
                  <span className="text-xs opacity-70">Bitiş: {formatEndDate(dp.end_date)}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Dialog>
  );
};

export default EmployeeDialog;
